import type React from "react";
import createExternalStore from "../../common/utils/createExternalStore";

type StickyAlert = {
    id: string;
    message: string;
    subMessage?: string;
    severity: "error" | "warning" | "info" | "success";
    icon?: React.ReactNode;
    autoHideDuration?: number;
    onClose?: () => void;
    timer?: NodeJS.Timeout;
};

export type State = {
    alert: StickyAlert | undefined;
};

export const initialState: State = {
    alert: undefined,
};

export const stickyAlertStore = createExternalStore(
    initialState,
    {
        setAlert: (state, alert: StickyAlert) => {
            if (state.alert?.timer) {
                clearTimeout(state.alert.timer);
            }
            return {
                ...state,
                alert,
            };
        },
        clearAlert: (state) => {
            if (state.alert?.timer) {
                clearTimeout(state.alert.timer);
            }
            return {
                ...state,
                alert: undefined,
            };
        },
    },
    "stickyAlertStore",
);

const defaultDuration = (severity: StickyAlert["severity"]) => {
    switch (severity) {
        case "error":
            return 5000;
        default:
            return 3000;
    }
};

export const setAlert = (alert: Omit<StickyAlert, "id" | "timer">) => {
    const id = Math.random().toString(36).substring(7);
    const autoHideDuration =
        alert.autoHideDuration === 0
            ? undefined
            : (alert.autoHideDuration ?? defaultDuration(alert.severity));
    const onClose = alert.onClose
        ? alert.onClose
        : () => {
              stickyAlertStore.dispatch("clearAlert");
          };
    const timer = autoHideDuration
        ? setTimeout(() => {
              stickyAlertStore.dispatch("clearAlert");
          }, autoHideDuration)
        : undefined;
    stickyAlertStore.dispatch("setAlert", { ...alert, id, timer, onClose });
};
export const removeAlert = () => {
    stickyAlertStore.dispatch("clearAlert");
};
